import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "cockpit-container",
  class: "kn-height-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentExecution = _resolveComponent("DocumentExecution")
  const _component_DocumentDetails = _resolveComponent("DocumentDetails")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_DocumentExecution, {
      id: _ctx.name,
      propMode: _ctx.mode,
      style: [_ctx.mode === 'document-execution' ? '' : 'display: none !important; '],
      parameterValuesMap: _ctx.parameterValuesMap,
      tabKey: _ctx.tabKey,
      onParametersChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('parametersChanged', $event))),
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
    }, null, 8, ["id", "propMode", "style", "parameterValuesMap", "tabKey"]), [
      [_vShow, _ctx.mode === 'document-execution']
    ]),
    _withDirectives(_createVNode(_component_DocumentDetails, {
      style: [_ctx.mode === 'document-detail' ? '' : 'display: none !important;'],
      propMode: 'execution',
      viewMode: _ctx.mode,
      propDocId: _ctx.item?.id,
      wholeItem: _ctx.item,
      propFolderId: _ctx.functionalityId,
      onCloseDetails: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('closeDetails', _ctx.item))),
      onDocumentSaved: _ctx.onDocumentsSaved
    }, null, 8, ["style", "viewMode", "propDocId", "wholeItem", "propFolderId", "onDocumentSaved"]), [
      [_vShow, _ctx.mode === 'document-detail']
    ])
  ]))
}